import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import svUserCaseImage from '@client/shared/images/landingPageAssets/sv/bg-user-case.png';
import noUserCaseImage from '@client/shared/images/landingPageAssets/no/bg-user-case.png';
import dkUserCaseImage from '@client/shared/images/landingPageAssets/dk/bg-user-case.png';
import enUserCaseImage from '@client/shared/images/landingPageAssets/sv/bg-user-case.png';
import Flex from '@client/components/flex/Flex';
import styleHelper from '@client/shared/styles/styleHelper.scss';
import styles from './userCase.scss';

const UserCase = () => {
  const { t, i18n } = useTranslation(['landing']);
  const { language } = i18n;

  const getUserCaseImageByLanguage = (language = 'sv') => {
    switch (language) {
      case 'sv':
        return `url(${svUserCaseImage})`;
      case 'no':
        return `url(${noUserCaseImage})`;
      case 'dk':
        return `url(${dkUserCaseImage})`;
      case 'en':
        return `url(${enUserCaseImage})`;
      default:
        return `url(${svUserCaseImage})`;
    }
  };

  return (
    <section className={styles.userCaseSection}>
      <div
        className={styles.bgImage}
        style={{ backgroundImage: getUserCaseImageByLanguage(language) }}
      >
        <Flex
          className={classNames(
            styleHelper.landingPageSectionContent,
            styles.contentContainer
          )}
        >
          <Flex column className={styles.marginAdjustment}>
            <h4
              className={classNames(
                styleHelper.landingDefaultText,
                styles.userCaseHeader
              )}
            >
              {t('UserCase.title')}
            </h4>
            <p
              className={classNames(
                styleHelper.landingP4,
                styleHelper.mgt16,
                styles.paragraph
              )}
            >
              {t('UserCase.description')}
            </p>
          </Flex>
        </Flex>
      </div>
    </section>
  );
};

export default UserCase;
